// src/components/Career/CareerJobPage.js

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getData } from "../../services/FetchNodeservices";
import PublicApplyForm from "./PublicApplyForm";

export default function CareerJobPage() {
  const { reqId } = useParams();

  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchJob();
  }, [reqId]);

  const fetchJob = async () => {
    try {
      const result = await getData(
        `job/job-details/${reqId}`
      );

      if (result.status) {
        setJob(result.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  if (loading) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <div className="text-lg font-medium">
          Loading Job Details...
        </div>
      </div>
    );
  }

  if (!job) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <div className="text-lg text-red-600">
          Job Not Found
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex justify-center items-center py-10 px-4 md:px-8">
      <div className="max-w-3xl w-full">
        <PublicApplyForm job={job} />
      </div>
    </div>
  );
}